import { useNavigate } from 'react-router-dom';
import { useCompare } from '../../context/CompareContext';
import CompareModal from './CompareModal';

export default function CompareBar() {
  const navigate = useNavigate();
  const {
    compareItems,
    removeFromCompare,
    clearCompare,
    openCompareModal,
    compareModalOpen,
    compareModeActive,
    activateCompareMode,
    deactivateCompareMode,
  } = useCompare();

  const handleAddSlot = () => {
    activateCompareMode();
    const firstItem = compareItems[0];
    const cat = firstItem?.category ?? '';
    navigate(`/products${cat ? `?category=${cat}` : ''}`);
  };

  return (
    <>
      {/* Compare mode overlay banner */}
      {compareModeActive && (
        <div
          className="fixed top-0 left-0 right-0 z-[200] flex items-center justify-center pointer-events-none"
          style={{ top: '72px' }}
        >
          <div
            className="pointer-events-auto flex items-center gap-3 px-5 py-3 rounded-2xl text-sm font-semibold shadow-2xl"
            style={{
              background: 'rgba(220,38,38,0.95)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(255,255,255,0.2)',
              color: '#fff',
            }}
          >
            <span className="w-2.5 h-2.5 bg-[#ffffff] rounded-full animate-pulse flex-shrink-0" />
            <span>Modo comparación — haz clic en cualquier producto para compararlo</span>
            <button
              onClick={deactivateCompareMode}
              className="ml-2 w-6 h-6 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-colors cursor-pointer flex-shrink-0"
            >
              <i className="ri-close-line text-white text-sm" />
            </button>
          </div>
        </div>
      )}

      {/* Floating compare bar */}
      <div
        className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${
          compareItems.length > 0 ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <div className="always-dark bg-zinc-950 border-t-2 border-red-600 shadow-2xl">
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
            {/* Left: slots */}
            <div className="flex items-center gap-3">
              <span className="text-zinc-400 text-xs font-bold uppercase tracking-wider whitespace-nowrap hidden sm:block">
                Comparando:
              </span>
              <div className="flex items-center gap-2 sm:gap-3">
                {[0, 1, 2].map((slot) => {
                  const item = compareItems[slot];
                  const isEmpty = !item;
                  const canAdd = isEmpty && compareItems.length > 0 && compareItems.length < 3;
                  return (
                    <div
                      key={slot}
                      onClick={canAdd ? handleAddSlot : undefined}
                      className={`relative flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-xl border-2 transition-all duration-200 ${
                        item
                          ? 'border-red-600 bg-zinc-900'
                          : canAdd
                          ? compareModeActive
                            ? 'border-red-500 bg-red-600/20 border-solid animate-pulse cursor-pointer'
                            : 'border-zinc-600 bg-zinc-900 border-dashed hover:border-red-500 cursor-pointer'
                          : 'border-zinc-700 bg-zinc-900 border-dashed opacity-50'
                      }`}
                      title={canAdd ? 'Haz click para seleccionar otro producto de la misma categoría' : undefined}
                    >
                      {item ? (
                        <>
                          <img
                            src={item.images?.[0] ?? item.image ?? ''}
                            alt={item.name}
                            className="w-full h-full object-contain p-0.5 rounded-xl bg-white"
                          />
                          <button
                            onClick={(e) => { e.stopPropagation(); removeFromCompare(item.id); }}
                            className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center bg-red-600 rounded-full cursor-pointer hover:bg-red-700 transition-colors"
                          >
                            <i className="ri-close-line text-white text-[10px]" />
                          </button>
                        </>
                      ) : (
                        <i className={`ri-add-line text-lg ${canAdd ? 'text-zinc-400' : 'text-zinc-700'}`} />
                      )}
                    </div>
                  );
                })}
              </div>
              <p className="text-zinc-500 text-xs hidden sm:block">
                {compareModeActive
                  ? <span className="text-red-400 animate-pulse">Selecciona un producto...</span>
                  : compareItems.length < 3
                  ? 'Agrega hasta 3 productos'
                  : 'Listo para comparar'
                }
              </p>
            </div>

            {/* Right: actions */}
            <div className="flex items-center gap-3">
              <span className="text-zinc-500 text-xs font-bold">
                {compareItems.length}/3
              </span>
              <button
                onClick={clearCompare}
                className="text-xs text-zinc-500 hover:text-zinc-300 uppercase tracking-wider font-bold transition-colors cursor-pointer whitespace-nowrap"
              >
                Limpiar
              </button>
              <button
                onClick={openCompareModal}
                disabled={compareItems.length < 2}
                className="flex items-center gap-2 bg-red-600 hover:bg-red-700 disabled:bg-zinc-700 disabled:text-zinc-500 text-white text-xs font-extrabold uppercase tracking-widest px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-swap-line" />
                <span className="hidden sm:inline">Comparar ahora</span>
                <span className="sm:hidden">Comparar</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Spacer when bar is visible */}
      {compareItems.length > 0 && <div className="h-20 sm:h-24" />}

      {/* Compare modal */}
      {compareModalOpen && <CompareModal />}
    </>
  );
}

